import { render, staticRenderFns } from "./TableImages.vue?vue&type=template&id=8fae752e"
import script from "./TableImages.vue?vue&type=script&lang=ts"
export * from "./TableImages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports